import { useContext, useEffect, useState } from 'react'
import AppContext from '@/AppContext'
import manufacturersService, { Manufacturer } from '@/utils/services/manufacturer'

export const useManufacturers = (): { manufacturers: Manufacturer[] } => {
  const { setToast, fireToast } = useContext(AppContext)
  const [manufacturers, setManufacturers] = useState<Manufacturer[]>([])

  const getManufacturers = async () => {
    try {
      const data = await manufacturersService.getManufacturers()
      setManufacturers(data)
    } catch (error) {
      setToast('error', error?.response?.data?.message || error?.message)
      fireToast()
    }
  }

  useEffect(() => {
    getManufacturers()
  }, [])

  return {
    manufacturers,
  }
}
